import { ResponseVM } from './response.model';

export class QuestionVM {
  libelle: string;
  responseVMs?: ResponseVM[];
  id?: number;

  constructor(libelle: string, responseVMs?: ResponseVM[], id?: number) {
    this.libelle = libelle;
    this.responseVMs = responseVMs;
    this.id = id;
  }
}
